// Inline SVG country flags. Used in the language switcher because emoji
// flags don't render on Windows / Chrome on Windows.
// 4:3-ish aspect ratio, sized via className.

export type FlagCountry = 'US' | 'BR' | 'ES' | 'FR' | 'IT' | 'CN';

interface FlagIconProps {
  country: FlagCountry;
  className?: string;
}

const FlagIcon = ({ country, className = 'h-3.5 w-5' }: FlagIconProps) => {
  if (country === 'US') {
    return (
      <svg viewBox="0 0 60 30" className={className} aria-hidden="true">
        <rect width="60" height="30" fill="#B22234" />
        {[1, 3, 5, 7, 9, 11].map((i) => (
          <rect key={i} y={i * (30 / 13)} width="60" height={30 / 13} fill="#fff" />
        ))}
        <rect width="24" height={30 * (7 / 13)} fill="#3C3B6E" />
      </svg>
    );
  }
  if (country === 'BR') {
    return (
      <svg viewBox="0 0 720 504" className={className} aria-hidden="true">
        <rect width="720" height="504" fill="#009C3B" />
        <polygon points="360,40 680,252 360,464 40,252" fill="#FFDF00" />
        <circle cx="360" cy="252" r="100" fill="#002776" />
      </svg>
    );
  }
  if (country === 'ES') {
    return (
      <svg viewBox="0 0 750 500" className={className} aria-hidden="true">
        <rect width="750" height="500" fill="#AA151B" />
        <rect y="125" width="750" height="250" fill="#F1BF00" />
      </svg>
    );
  }
  if (country === 'FR') {
    return (
      <svg viewBox="0 0 3 2" className={className} aria-hidden="true" preserveAspectRatio="none">
        <rect width="1" height="2" x="0" fill="#0055A4" />
        <rect width="1" height="2" x="1" fill="#FFFFFF" />
        <rect width="1" height="2" x="2" fill="#EF4135" />
      </svg>
    );
  }
  if (country === 'IT') {
    return (
      <svg viewBox="0 0 3 2" className={className} aria-hidden="true" preserveAspectRatio="none">
        <rect width="1" height="2" x="0" fill="#009246" />
        <rect width="1" height="2" x="1" fill="#FFFFFF" />
        <rect width="1" height="2" x="2" fill="#CE2B37" />
      </svg>
    );
  }
  // CN
  return (
    <svg viewBox="0 0 30 20" className={className} aria-hidden="true">
      <rect width="30" height="20" fill="#DE2910" />
      <g fill="#FFDE00">
        <polygon points="5,3 5.95,5.9 8.85,5.9 6.5,7.7 7.45,10.6 5,8.8 2.55,10.6 3.5,7.7 1.15,5.9 4.05,5.9" />
        <polygon points="10,1.5 10.3,2.4 11.25,2.4 10.45,3 10.75,3.9 10,3.35 9.25,3.9 9.55,3 8.75,2.4 9.7,2.4" />
        <polygon points="12,4 12.3,4.9 13.25,4.9 12.45,5.5 12.75,6.4 12,5.85 11.25,6.4 11.55,5.5 10.75,4.9 11.7,4.9" />
        <polygon points="12,7.5 12.3,8.4 13.25,8.4 12.45,9 12.75,9.9 12,9.35 11.25,9.9 11.55,9 10.75,8.4 11.7,8.4" />
        <polygon points="10,10 10.3,10.9 11.25,10.9 10.45,11.5 10.75,12.4 10,11.85 9.25,12.4 9.55,11.5 8.75,10.9 9.7,10.9" />
      </g>
    </svg>
  );
};

export default FlagIcon;
